// extracted by mini-css-extract-plugin
export default {"page":"ChatPage_page__zubut","iframe":"ChatPage_iframe__2fjc4","bottomTab":"ChatPage_bottomTab__TS+Z1"};